import React from "react";

const CustomerCart = ({ img, content, value, maxCount, add }) => {
  return (
    <div className="text-white my-[10px]  ">
      <div className=" md:flex">
        <div className="flex mx-auto w-20  h-20 ">
          <img src={img} alt="" className=" object-cover" />
        </div>
        <div>
          <h3 className="home-metric-value mt-[8px] flex justify-center text-center">
            {value}
            <b className="ml-[3%]">{add}</b>
          </h3>
          <p className="home-metric-label w-[170px] text-center md:w-[200px]">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomerCart;
